import { render, staticRenderFns } from "./cleanUnstanard.vue?vue&type=template&id=da1edcd6"
import script from "./cleanUnstanard.vue?vue&type=script&lang=js"
export * from "./cleanUnstanard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports